/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-10 08:38:48
 */

import {ColDefCustom, default as AgGridVueCustomTsx} from "src/components/agGridCustom/agGridVueCustomTsx";
import ListPageService from 'src/types/ListPage';
import override from "src/dectorators/override";
import {QueryFormVOI} from "src/components/queryForm/queryForm";
import ControlRecord from '../controlRecord';
import DeviceControlApi, { DeviceControlDOI } from '../api/deviceControlApi';
import DatePicker from 'src/types/iview/DatePicker';
import EnumDivisor from 'src/enums/enumDivisor';
import { DateTimeUtil } from 'src/util/dateTimeUtil';

export default class ControlRecordService extends ListPageService {
	ctx: ControlRecord;

	constructor (ctx: ControlRecord) {
	    super()
		this.ctx = ctx
	}

    @override
	createColumns (): ColDefCustom [] {
		return [
			{
				headerName: '时间',
				field: 'operation_time',
				minWidth: 180,
                cellRenderer(params) {
                    let data: DeviceControlDOI.RowDataI = params.data
                    return DateTimeUtil.formateDate(data.operation_time)
                }
			},
			{
				headerName: '组分',
				field: 'polid',
                minWidth: 100,
                cellRenderer(params) {
                    let data: DeviceControlDOI.RowDataI = params.data
                    return EnumDivisor.findCode(data.polid).getName()
                }
			},
			{
				headerName: '操作',
				field: 'operating_name',
				minWidth: 190
			},
			{
				headerName: '结果',
				field: 'operating_result',
				minWidth: 140
			}
		]
	}

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
				component: DatePicker,
				label: '时间',
                field: 'time',
                width: 300,
                realField: ['start_time','end_time'],
                timeType: 'number',
                props: {value: [], type: 'daterange', format: 'yyyy-MM-dd',placeholder: '请选择时间'},
            },
        ];
    }

	@override
	initSearchParams (): void {
		this.ctx.searchParams = this.ctx.queryForm.getQueryObj<DeviceControlDOI.QueryRowDataParamsI>()
		this.ctx.currentPage = 1
	}

    @override
	async searchTable () {
		let ctx = this.ctx
        let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
		ag.showLoading()
		let {code, data} = await DeviceControlApi.searchRecordList({
            ...ctx.searchParams,
            mn: ctx.mn,
			page_size: ctx.pageSize,
			page_index: ctx.currentPage
		})
		ag.hideLoading()

		if (code === 0) {
			ctx.rowData = data.data_info || []
			ctx.total = data.page_count
		}
	}

}